import { render, staticRenderFns } from "./EvalPreview.vue?vue&type=template&id=0568866e&scoped=true"
import script from "./EvalPreview.vue?vue&type=script&lang=js"
export * from "./EvalPreview.vue?vue&type=script&lang=js"
import style0 from "./EvalPreview.vue?vue&type=style&index=0&id=0568866e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568866e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0568866e')) {
      api.createRecord('0568866e', component.options)
    } else {
      api.reload('0568866e', component.options)
    }
    module.hot.accept("./EvalPreview.vue?vue&type=template&id=0568866e&scoped=true", function () {
      api.rerender('0568866e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/EvalPreview.vue"
export default component.exports